import { render, staticRenderFns } from "./pointGoodsList.vue?vue&type=template&id=3dfa2592&scoped=true&"
import script from "./pointGoodsList.vue?vue&type=script&lang=js&"
export * from "./pointGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./pointGoodsList.vue?vue&type=style&index=0&id=3dfa2592&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfa2592",
  null
  
)

export default component.exports